<template>
  <v-textarea
    ref="inputRef"
    v-model="chatInputMessageLocale"
    :placeholder="placeholder"
    class="msg-input"
    solo
    auto-grow
    rows="1"
    no-resize
    validate-on-blur
    :hide-details="clicouNoIconeDeAudio || 'auto'"
    :readonly="readonly"
    :disabled="disabled"
    @keydown.enter.exact.prevent="handleSendMessageClick"
  >
    <template #label>
      <marquee
        v-if="mostrarLetreiro"
        scrollamount="10"
      >
        {{ placeholder }}
      </marquee>
    </template>

    <template #append>
      <div class="d-flex align-center">
        <v-expand-transition>
          <audio-recorder
            v-if="podeGravarAudio && !apagarAudio"
            :loading="loading"
            :disabled="ticketEstaFinalizado"
            @update:audio-data-url="v => audioDataUrlLocale = v"
            @update:clicou-no-icone-de-audio="v => clicouNoIconeDeAudio = v"
          />
        </v-expand-transition>

        <chat-input-anexo-btn
          v-if="ticketId"
          :handle-upload-anexos="handleUploadAnexos"
          :editavel="editavel"
          :loading="loading"
          :clicou-no-icone-de-audio="clicouNoIconeDeAudio"
          :ticket-esta-finalizado="ticketEstaFinalizado"
          :notificar-obrigatoriedade-do-envio-do-template-de24-horas="templateWhatsApp24HorasProps.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas"
        />

        <chat-input-send-btn
          v-if="ticketId"
          :handle-send-message-click="handleSendMessageClick"
          :editavel="editavel"
          :loading="loading"
          :ticket-esta-finalizado="ticketEstaFinalizado"
          :notificar-obrigatoriedade-do-envio-do-template-de24-horas="templateWhatsApp24HorasProps.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas"
          :proibir-envio-de-mensagem-do-atendente-pelo-fato-de-a-ultima-mensagem-ser-um-template-de24-horas="templateWhatsApp24HorasProps.proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas"
        />
      </div>
    </template>
  </v-textarea>
</template>

<script>
import { ref, computed, watchEffect } from '@vue/composition-api'
import { mdiMicrophone } from '@mdi/js'
import AudioRecorder from '@/components/audio-recorder/AudioRecorder.vue'
import ChatInputAnexoBtn from './ChatInputAnexoBtn.vue'
import ChatInputSendBtn from './ChatInputSendBtn.vue'

export default {
  emits: ['update:chat-input-message', 'update:audio-data-url'],

  components: {
    AudioRecorder,
    ChatInputAnexoBtn,
    ChatInputSendBtn,
  },

  props: {
    ticketId: {
      type: Number,
      default: 0,
    },
    chatInputMessage: {
      type: String,
      required: true,
    },
    templateWhatsApp24HorasProps: {
      type: Object,
      required: true,
    },
    handleUploadAnexos: {
      type: Function,
      required: true,
    },
    handleSendMessageClick: {
      type: Function,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    podeGravarAudio: {
      type: Boolean,
      required: true,
    },
    apagarAudio: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const chatInputMessageLocale = ref('')
    const audioDataUrlLocale = ref(null)
    const clicouNoIconeDeAudio = ref(false)

    watchEffect(() => { chatInputMessageLocale.value = props.chatInputMessage })
    watchEffect(() => { emit('update:chat-input-message', chatInputMessageLocale.value) })
    watchEffect(() => { emit('update:audio-data-url', audioDataUrlLocale.value) })

    const mostrarLetreiro = computed(() => props.templateWhatsApp24HorasProps.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas || props.templateWhatsApp24HorasProps.proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas)

    const placeholder = computed(() => {
      if (props.templateWhatsApp24HorasProps.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas) {
        return props.templateWhatsApp24HorasProps.mensagemDeObrigatoriedadeDoEnvioDoTemplateDe24Horas
      } if (props.templateWhatsApp24HorasProps.proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas) {
        return props.templateWhatsApp24HorasProps.mensagemDeProibicaoDoEnvioDeMensagemDoAtendentePeloFatoDeOSolicitanteAindaNaoTerRespondidoOTemplateDe24Horas
      }
      return 'Digite sua mensagem (mínimo de 20 caracteres)'
    })

    const readonly = computed(() => (
      props.templateWhatsApp24HorasProps.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas
        || !!audioDataUrlLocale.value
        || clicouNoIconeDeAudio.value
    ))

    const disabled = computed(() => (
      !props.editavel
        || props.loading
        || props.ticketEstaFinalizado
        || props.templateWhatsApp24HorasProps.proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas
    ))

    const inputRef = ref(null)
    const inputRefWidth = computed(() => inputRef.value?.$el.clientWidth + 400 || 1000)

    return {
      chatInputMessageLocale,
      audioDataUrlLocale,
      clicouNoIconeDeAudio,
      mostrarLetreiro,
      placeholder,
      readonly,
      disabled,
      inputRef,
      inputRefWidth,
      icons: {
        mdiMicrophone,
      },
    }
  },
}
</script>
